import { Dayjs, isDayjs } from 'dayjs';

export const dateToIsoStringWithoutTimezone = (inputDate: Date | Dayjs | string | null | undefined): string | null => {
  let actualDate: Date;

  if (inputDate == null) return null;

  if (inputDate instanceof Date) {
    actualDate = inputDate;
  } else if (isDayjs(inputDate)) {
    actualDate = inputDate.toDate();
  } else {
    actualDate = new Date(inputDate);
  }

  return new Date(Date.UTC(actualDate.getFullYear(), actualDate.getMonth(), actualDate.getDate())).toISOString();
};
